<template>
<select class="form-control" name="status" @change="updateContactStatus" v-model="inStatus">
    <option value="0">未處理</option>
    <option value="1">已處理</option>
</select>

</template>

<script>
    export default {
        props: ['id', 'status'],

        data(){
            return {
                inStatus: 0
            }
        },

        mounted()
        {
            let vm = this;
            vm.inStatus = vm.status
        },

        methods: {
            updateContactStatus()
            {
                let vm = this;
                let params = {
                    status: vm.inStatus
                }

                axios.patch(`/backend/contact/${this.id}`, params).then(r => {
                    console.log(r.data);
                });
            }
        }
    }
</script>
